export default __webpack_public_path__ + "static/media/gallery_01.625ba395.jpg";